if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.isBundleInnerVariant = !1;
        if (this.classList != null && this.classList.contains("variant-bundle-selects")) {
            this.isBundleInnerVariant = !0
        }
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        if (!this.isBundleInnerVariant) {
          this.addEventListener('change', (event) => {
            const target = this.getInputForEventTarget(event.target);
            this.updateSelectedSwatchValue(event);
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          });
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}


/* Custom JS - Bundle inner variant - Starts */
customElements.get("variant-selects-inner")||customElements.define("variant-selects-inner",class extends HTMLElement{constructor(){super()}get selectedOptionValues(){return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map((({dataset:e})=>e.optionValueId))}getInputForEventTarget(e){return"SELECT"===e.tagName?e.selectedOptions[0]:e}connectedCallback(){this.addEventListener("change",(e=>{const t=this.getInputForEventTarget(e.target);this.updateSelectedSwatchValue(e),FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,{data:{event:e,target:t,selectedOptionValues:this.selectedOptionValues}})}))}updateSelectedSwatchValue({target:e}){const{value:t,tagName:s}=e;if("SELECT"===s&&e.selectedOptions.length){Array.from(e.options).find((e=>e.getAttribute("selected"))).removeAttribute("selected"),e.selectedOptions[0].setAttribute("selected","selected");const t=e.selectedOptions[0].dataset.optionSwatchValue,s=e.closest(".product-form__input").querySelector("[data-selected-value] > .swatch");if(!s)return;t?(s.style.setProperty("--swatch--background",t),s.classList.remove("swatch--unavailable")):(s.style.setProperty("--swatch--background","unset"),s.classList.add("swatch--unavailable")),s.style.setProperty("--swatch-focal-point",e.selectedOptions[0].dataset.optionSwatchFocalPoint||"unset")}else if("INPUT"===s&&"radio"===e.type){const s=e.closest(".product-form__input").querySelector("[data-selected-swatch-value]");s&&(s.innerHTML=t)}}});
/* Custom JS - Bundle inner variant - Ends */